import React from "react";
import PropTypes from "prop-types";
import {
  HeaderContainer,
  LogoImage,
  HeaderContent,
  HeaderTitle
} from "./Header.styles";
import logo from "../../assets/logo-v2.png";

const Header = ({ isSidebarExpanded }) => {
  return (
    <HeaderContainer isSidebarExpanded={isSidebarExpanded}>
      <HeaderContent>
        <HeaderTitle>SECRETARIA DE ESTADO DE SAÚDE DE MINAS GERAIS - SES-MG</HeaderTitle>
        <LogoImage src={logo} alt="Brasão do Estado de Minas Gerais" />
      </HeaderContent>
    </HeaderContainer>
  );
};

Header.propTypes = {
  isSidebarExpanded: PropTypes.bool,
};

Header.defaultProps = {
  isSidebarExpanded: false,
};

export default Header;
